var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationFilled = function SvgLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 0C7.58 0 4 3.58 4 8c0 3.655 1.93 7.583 3.828 10.627 1.899 3.043 3.798 5.203 3.798 5.203.095.107.232.17.375.17a.507.507 0 0 0 .375-.17s1.9-2.205 3.797-5.266C18.07 15.504 20 11.584 20 8.001 20 3.581 16.42 0 12 0Zm0 6c1.387 0 2.5 1.114 2.5 2.5 0 1.388-1.113 2.5-2.5 2.5a2.493 2.493 0 0 1-2.5-2.5C9.5 7.115 10.614 6 12 6Z"
  })));
};
export { SvgLocationFilled as ReactComponent };